import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class User extends FirebaseModel {
	static entity = 'users';
	static baseCollection = this.firestore.collection('users');
	static fields(){
		return {
			disabledAfk: this.attr(null),
			email: this.number(null).nullable(),
			keep_alive: this.attr(null),
			logged_in: this.attr(null),
			name: this.attr(null),
			permissions: this.attr(null),
			reason: this.attr(null),
			updated: this.attr(null),
			advanced_billing_options: this.attr(null),
			...super.fields(),
		}
	}
	static ignoredFields(){
		return [
			...super.ignoredFields(),
			'test_type'
		]
	}
}
